<template>
   <div class="uk-width-1-1 uk-clearfix" @click="act = 0">  
    <div class="uk-overlay-panel uk-flex uk-flex-center uk-flex-middle uk-overlay-panel-loading" :class="is_open == 1 ? 'ipp-open' : ''" v-if="is_open == 1">
      <div class="ipp-twofa-box uk-panel uk-panel-box uk-panel-box-secondary uk-form">
        <div class="uk-text-right"><a @click="closeModel" class="uk-close uk-modal-close"></a></div>
        <h3 class="uk-text-center uk-margin-small-top">{{$t('two_fa_code.pls_enter_code')}}</h3> 
        <hr>
        <div class="uk-width-1-1 uk-margin-large-bottom">
          <div class="uk-margin-bottom uk-text-center">
            {{$t('two_fa_code.tips')}}
          </div>
          <div class="pay-password" @click="handleClick" @click.stop="act = 1" :class="act == 1 ? 'act' : ''">
            <input type="text" ref="inputs" class="real-ipt" maxlength="6" v-model="is_twofa_code">
            <div class="surface-line"><span v-for="j in len"></span></div>
            <div class="surface"><span v-for="j in is_twofa_code">{{j}}</span></div>
          </div>                                
        </div>
      </div>     
    </div>



    <!-- 判断版本号显示刷新 -->
    <div class="uk-panel ipp-version" v-if="is_show_version == 1" @click="refresh">  
      {{$t('setting.version')}} | <span class="uk-icon-refresh"></span>
    </div>
    
    <!-- 返回顶部 -->
    <div v-if="btnFlag" id="gotop" @click="backTop" class="uk-icon-chevron-up"></div>
  </div>
</template>
<script>
import {debounce} from '@/components/common/resouces/debounce'
export default {
  name: 'bottomtips',
  data () {
    return {                  
        currname:'',        
        is_twofa_code:'',
        len:6,       
        is_open:0,
        info:[],
        url:'',
        name:'',
        act:0,
        btnFlag:false,
        tips_name:'' //标识名称，方便回调后获取使用       
    }
  },
  created(){
    this.$watch('is_twofa_code', debounce((val) => {        
        this.checkInput(this.is_twofa_code);  
    }, 100));
  },
  mounted: function() {
   
    //
  },
  computed:{
    domain(){
      return this.$store.state.home.domain
    }, 
    userInfo(){
      return this.$store.state.home.userInfo
    },
    enterKey(){
      return this.$store.state.home.enterKey
    },
    is_show_version(){
      return this.$store.state.home.is_show_version;
    }
  },
  activated:function(){
    window.addEventListener('scroll', this.scrollToTop)
    let name = this.$route.name
    this.currname = name 
    //在当前的路由列表中，可以直接使用回车进行搜索
    let self = this
    document.onkeydown = function(e) {
      let ev = document.all ? window.event : e
      if (ev.keyCode === 13 && self.routelist.indexOf(name) > -1){
        self.$store.state.loading.loading = true        
        self.$parent.chooseLang();       
      }
    }
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods:{

    getSubmitArray(v,url,need_secret,name){          
      this.info = v
      this.url = url   
      if(name){
        this.tips_name = name            
      }
      if(need_secret && need_secret == 1){
        this.is_open = 1
        this.handleClick();
      }else{
        this.submit(v,this.url,this.tips_name);
      }
      
    },

    handleClick(v){
      this.focus();
      this.act = 1    
    },
    focus(){
      this.$nextTick(() => {
        this.$refs.inputs.focus();    
      });

    },
    
    checkInput(v){
      //有值且只能是数字（正则)
      if (/^[0-9]*$/g.test(v)){
        if(v.length == this.len){                       
          var array = this.info           
          array.secret_code = v          
          this.submit(array,this.url,this.tips_name);
        }
      }else{
        var val = v.slice(0,-1);       
        this.is_twofa_code = val
      }
    },      
    submit(array,postUrl){
      this.$store.state.loading.loading = true      
      this.$post(postUrl,array).then((res)=>{ 
        if(res.data.errcode == 0){
          this.$parent.callback(res.data.errcode,res.data.errmsg,res.data.data,this.tips_name);
          this.closeModel();
        }       
        else{
          this.alert(-1,res.data.errmsg);
          this.is_twofa_code = ''
        }
      });
    },  
    closeModel(){
      this.is_open = 0
      this.is_twofa_code = ''
      this.info = []
    },
    
    
    download_scv(json,url){    
        let lang = localStorage.getItem("language")            
        let token = 'Bearer ' +localStorage.getItem("access_token")   
        let info = json
        info.Authorization = token
        info.lang = lang     
        var params = Object.keys(info).map(function (key){
            return encodeURIComponent(key) + "=" + encodeURIComponent(info[key]);
        }).join("&");
        let file_url = url + '?'+params
        window.location.href = file_url
    },
    

    ukalert(v){
      if(v){
        UIkit.modal.alert(v);
      }else{
        UIkit.modal.alert('');
      }
    },

    //提示
    alert(v,msg){
      console.log(v)
      console.log(msg)

      if(v == 0){
        this.$my_message({
          content:msg,
          time:1000
        });
      }else if(v == '-201' ||  v == '-203'  || v == '-204' ){
        this.$store.state.home.token_status = 1        
        this.getRefreshToken();          
        return
      }else if(v == -304){       
        this.$router.replace('/Merchant/merchant?merchant_no='+localStorage.getItem("current_merchant_no"));      
      }else if(v == -344){
        this.$router.replace('/error/update');
      }else if(v == -345){
        this.$router.replace('/Error/need_bind');
      }else if(v == -350){
        this.$router.replace('/error/no_permissions');
      }else{
        this.$my_message({
          content:msg,
          type:'close',
          time:3000
        });
      }
    },    
    refresh(){
      window.location.reload();      
    },
    backTop () {
        const that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
    },
   
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    getRefreshToken(){      
      var url =  this.domain + '/User/refreshToken'     
      this.$post(url).then((res)=>{ 
        if(res.data.errcode == 0){   
            this.$store.state.home.token_status = 0         
            window.localStorage.setItem('access_token', res.data.data.access_token);
            this.$parent.chooseLang();
        }else{
          this.alert(res.data.errcode,res.data.errmsg);
          window.localStorage.removeItem('access_token');
          window.localStorage.removeItem('refresh_token');
          window.localStorage.removeItem('token_type');
          window.localStorage.removeItem('current_merchant_no');                    
          this.router.replace('/login');              
          return
        }
      });
    }    
  }
}
</script>
<style scoped lang="scss">
.uk-overlay-panel-loading{position:fixed;z-index: 88888; background:rgba(0,0,0,.8); }
</style>



// WEBPACK FOOTER //
// src/components/information/bottomtips.vue